/**
 * Get the default values for print options. Optionally pass in an existing options object to fill in any missing values
 */
export function printOptionDefaults(options = {}) {
    return {
        layout: 'session',
        orientation: 'portrait',
        view: 'expanded',
        instructions: 'inline',
        printBaseBlock: false,
        exerciseId: null,
        metricIds: [],
        sets: null,
        brandColor: null,
        locale: null,
        lettering: 'all',
        fitToPage: false,
        headerText: null,
        headerSize: 'normal',
        eachSidePlacement: 'exercise',
        ...options,
    };
}
//# sourceMappingURL=print-options.js.map